import { Input, Popover, CheckboxGroup, CheckboxButton } from 'element-ui';
import { EventBus } from '@/services/Event.js';

export default {
    name: 'CheckBoxAnswer',
    props: {
        id: [Number, String],
        value: Boolean,
        label: String,
        label_class: { type: String, default: '' },
        disabled: Boolean,
        visible: { type: Boolean, default: true },
        hint: String,
        hint_type: { type: String, default: 'warning' },
        false_answer_label_prop: String,
        true_answer_label_prop: String,
        visibility_dependent_fields: Array,
        smallest: { type: String, default: 'col-12' }, small: { type: String, default: 'col-sm-12' }, medium: { type: String, default: 'col-md-12' }, large: { type: String, default: 'col-lg-12' }, largest: { type: String, default: 'col-lg-12' },
        options: Array,
        is_mandatory: Boolean,
        error_messages: Array,
    },
    components: {
        [Input.name]: Input,
        [Popover.name]: Popover,
        [CheckboxButton.name]: CheckboxButton,
        [CheckboxGroup.name]: CheckboxGroup,
    },
    computed: {
        mandatory_text() {
            return 'This field is mandatory to be in status ' + '\"' + this.true_answer_label + '\"'
        },
        is_yes() {
            return this.prop_value[0] == this.true_answer_label;
        },
        column_class() {
            return `${this.largest} ${this.large} ${this.medium} ${this.small} ${this.smallest}`
        },
        label_class_value() {
            return "float-left"
        },
        false_answer_label() {
            if (this.false_answer_label_prop) {
                return this.false_answer_label_prop;
            }
            return "No";
        },
        true_answer_label() {
            if (this.true_answer_label_prop) {
                return this.true_answer_label_prop;
            }
            return "Yes";
        },
    },
    watch: {
        value: { // watch it
            immediate: true,
            handler(val, oldVal) {
                this.prop_value = [val ? this.true_answer_label : this.false_answer_label];
                this.handler_change();
            }
        },
        options: {
            immediate: true,
            handler(val, oldVal) {
                if (!val) {
                    this.setOptions();
                }
                this.handler_change();

            }
        }
    },
    data() {
        return {
            prop_value: false,
        };
    },
    methods: {
        update_error(message) {
            if (message) {
                this.prop_valid = false;
                this.$emit("update:valid", false);
                this.$emit("update:error_messages", [message]);
            }
            else {
                this.prop_valid = true;
                this.$emit("update:valid", true);
                this.$emit("update:error_messages", []);
            }
        },
        validate() {
            var message = this.is_mandatory && !this.is_yes ?
                `This field is mandatory to be in status ${this.true_answer_label}` : null;
            this.update_error(message);
        },
        handler_click(value) {
            if (this.disabled) {
                return;
            }
            if (value) {
                this.prop_value = [value];
            }
            this.handler_change();
        },
        handler_change() {
            var self = this;
            self.validate();
            self.$emit("update:value", this.is_yes);
            if (self.visibility_dependent_fields && self.visibility_dependent_fields.length) {
                setTimeout(() => self.visibility_dependent_fields.forEach(enumValue => {
                    EventBus.$emit(`update-visibility-field-id-${enumValue}`, self.is_yes ? 1 : 0)
                }), 0);
            }
        },
        remove_tab_index() {
            if (this.$refs && Object.keys(this.$refs).length) {
                Object.keys(this.$refs).forEach(prop => {
                    if (this.$refs[prop] && this.$refs[prop].$el && this.$refs[prop].$el.children && this.$refs[prop].$el.children.length) {
                        this.$refs[prop].$el.children[1].tabIndex = -1;
                    }
                })
            }
        },
        setOptions() {
            var options = [];
            options.push(this.false_answer_label);
            options.push(this.true_answer_label);

            this.$emit("update:options", options);
        }
    },
    mounted() {
        var self = this;
        if (!this.options || this.options.length) {
            this.setOptions();
            this.handler_change();
        }
        this.remove_tab_index();

        EventBus.$off(`handler-change-answer-id-${this.id}`);
        EventBus.$on(`handler-change-answer-id-${this.id}`, () => { self.handler_change(); });
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/answer-types/checkbox/checkbox.js